import client from './client'

const getAllChatflows = () => client.get('/flows')

// const getSpecificChatflow = (id: string) => client.get(`/flows/${id}`)
const getSpecificChatflow = (id: string) => client.get(`/api/list-tool/${id}`)

const getSpecificChatflowFromPublicEndpoint = (id: string) => client.get(`/public-chatflows/${id}`)

// const createNewChatflow = (body: any) => client.post(`/flows`, body)
const createNewChatflow = (body: any) => client.post(`/api/add-tools`, body)
const createNewChatflowVersion = (id: string, body: any) => client.post(`/flows/${id}`, body)

// const updateChatflow = (id: string, body: any) => client.put(`/flows/${id}`, body)

const updateChatflow = (body: any) => client.post(`/api/update-tools`, body)

const deleteChatflow = (id: string) => client.delete(`/api/delete-tool/${id}`)

const getIsChatflowStreaming = (id: string) => client.get(`/chatflows-streaming/${id}`)

export default {
    getAllChatflows,
    createNewChatflowVersion,
    getSpecificChatflow,
    getSpecificChatflowFromPublicEndpoint,
    createNewChatflow,
    updateChatflow,
    deleteChatflow,
    getIsChatflowStreaming
}
